import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

function CustomCalendar({ onDateChange, minDate, selectedRowId, selectedDate, dateData }) {
  console.log(dateData, "DATE DATA OF CALENDAR");
  
  const parseDate = (dateString) => {
    if (!dateString) return null;
    
    const parts = dateString.split("/");
    if (parts.length !== 3) return null; 
  
    const month = parseInt(parts[0], 10) - 1; 
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
  
    return new Date(year, month, day, 12, 0, 0); 
};

const disabledDatesSet = new Set(dateData.map(item => new Date(item.date).toDateString()));

  const isDisabledDate = (date) => {
    return (minDate && date < minDate) || disabledDatesSet.has(date.toDateString());
  };
  
  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const isSelectedRowDate = (date) => {
    if (!selectedDate) return false;
    const rowDate = parseDate(selectedDate);
    return (
      rowDate &&
      date.getDate() === rowDate.getDate() &&
      date.getMonth() === rowDate.getMonth() &&
      date.getFullYear() === rowDate.getFullYear()
    );
  };

  const defaultStartDate = parseDate(selectedRowId) || new Date();

  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      <style>
        {`
          .react-calendar {
            width: 100%;
            max-width: 375px;
            margin: 0 auto;
            box-sizing: border-box;
          }

          .react-calendar__navigation button {
            color: #121212;
          }

          .react-calendar__month-view__weekdays {
            font-size: 14px;
            font-weight: 400;
            color: #121212;
          }

          .react-calendar__month-view__weekdays abbr {
            text-decoration: none;
            border: none;
          }

          .react-calendar__tile {
            padding: 5px;
            font-size: 12px;
            text-align: center;
            width: 20px;
            height: 50px;
          }

          .react-calendar__tile--weekend {
            color: inherit;
          }

          .highlight {
            background-color: #FF7900;
            border-radius: 50%;
            width: 20px;
            height: 50px;
          }

          .react-calendar__tile--disabled {
            background-color: transparent !important;
            color: grey !important;
            pointer-events: none;
          }

          .react-calendar__tile--today {
            background-color: #FF7900 !important;
            color: white !important;
            border-radius: 50%;
            font-weight: bold;
          }

          .react-calendar__tile--selected-row {
            background-color: #FF7900 !important;
            color: white !important;
            border-radius: 50%;
            font-weight: bold;
          }

          .react-calendar__navigation button.react-calendar__navigation__label {
            pointer-events: none;
            color: #121212;
            background: none;
            border: none;
          }

          .react-calendar__navigation button.react-calendar__navigation__arrow {
            pointer-events: auto;
          }

          @media (max-width: 375px) {
            .react-calendar {
              max-width: 100%;
            }

            .react-calendar__tile {
              padding: 3px;
              font-size: 10px;
              width: 30px;
              height: 30px;
            }

            .react-calendar__tile--now,
            .react-calendar__tile--now.react-calendar__tile--active,
            .highlight {
              width: 30px;
              height: 30px;
            }

            .react-calendar__month-view__weekdays {
              font-size: 10px;
            }

            .react-calendar__navigation button {
              font-size: 12px;
            }
          }
        `}
      </style>
      <Calendar
        minDate={minDate}
        onChange={onDateChange}
        value={parseDate(selectedDate)} 
        defaultActiveStartDate={parseDate(selectedDate) || new Date()} 
        tileDisabled={({ date }) => isDisabledDate(date)}
        tileClassName={({ date }) => {
          if (isDisabledDate(date)) return "react-calendar__tile--disabled";
          if (isToday(date)) return "react-calendar__tile--today";
          if (isSelectedRowDate(date)) return "react-calendar__tile--selected-row";
          return null;
        }}
        next2Label={null}
        prev2Label={null}
        navigationLabel={({ date }) =>
          `${date.toLocaleString("default", {
            month: "long",
          })} ${date.getFullYear()}`
        }
      />
    </div>
  );
}

export default CustomCalendar;
